<template>
    <rkm-modal
        :loading="loading"
        :title="`Sala - ${infraestrutura.nome} (${centroCusto.setorNome})`"
        large
        ref="Modal"
        hide-footer
    >
        <Form
            :centroCusto="centroCusto"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        infraestrutura: {},
        centroCusto: {},
    }),
    methods: {
        open(infraestrutura, centroCusto) {

            this.infraestrutura = infraestrutura
            this.centroCusto = centroCusto

            this.$refs.Modal.show()
        },
    },
}
</script>